<div [formGroup]="group()">
    <div class="fields row">
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.epc.oat" | translate }}</span>
            <kendo-textbox formControlName="oat"></kendo-textbox>
        </label>
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.epc.altitude" | translate }}</span>
            <kendo-textbox formControlName="altitude"></kendo-textbox>
        </label>
    </div>
    @for (engine of engines(); track engine) {
        <fieldset class="group">
            <legend>{{ "FLIGHT_LIST.epc.engine" | translate: { engine: engine } }}</legend>
            <div class="fields readings">
                @for (reading of readings; track reading.field) {
                    <label class="field">
                        <span class="label">{{ reading.label }}</span>
                        <kendo-textbox [formControlName]="engine === 1 ? reading.engine1 : reading.engine2"></kendo-textbox>
                    </label>
                }
            </div>
        </fieldset>
    }
</div>
